import { render, staticRenderFns } from "./ApartmentsView.vue?vue&type=template&id=0f3c38d3&lang=pug&"
import script from "./ApartmentsView.vue?vue&type=script&lang=ts&"
export * from "./ApartmentsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports